import { api } from '@services/api'
import { FranchiseIndex, FranchiseIndexDto, FranchiseShowDto } from './types'
import qs from 'qs'

const index = (params: FranchiseIndex) =>
  api.get<FranchiseIndexDto>('/franchises', {
    params: params,
    paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })

const show = (slug: string) => api.get<FranchiseShowDto>(`/franchises/${slug}`)

export const FranchiseApi = {
  index,
  show
}
